import { Component, OnInit, Input } from '@angular/core';
import { SmartLabelTemplate } from '../smart-label-template';
import { SmartLabelService } from '../smart-label.service';

@Component({
  selector: 'smart-label-beverage',
  templateUrl: './smart-label-beverage.component.html',
  styleUrls: ['../smart-label.component.scss', './smart-label-beverage.component.scss']
})
export class SmartLabelBeverageComponent extends SmartLabelTemplate implements OnInit {
  @Input() config;
  constructor(private smartLabelService: SmartLabelService) {
    super();
  }
  /**
   * @author - SwapnilP
   * @task - QLIKTAG-2888
   */
  ngOnInit() {
  }

}
